module.exports = __webpack_public_path__ + "static/media/19.9ce2c86b.jpeg";